<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('sidebar.dstk')" />
      <h3>{{ $t('sidebar.dstk') }}</h3>
      <div class="row">
        <div class="col-lg-8">
          <div
            v-if="requests.length<1"
            class="alert alert-info"
          >
            {{ $t('feedback.heBirDstkSorusuQeydAlnmamdr') }}
          </div>

          <div
            v-for="o in requests"
            :key="o.id"
            class="card"
          >
            <div class="card-header f-w-600 py-3">
              <div class="d-flex justify-content-between">
                <div>#{{ buildLongId(o.id, 5) }}</div>
                <div>
                  <span
                    v-if="o.status === 0"
                    class="badge bg-warning"
                  >{{ $t('myCabinetMenu.yeni') }}</span>
                  <span
                    v-else-if="o.status === 1"
                    class="badge bg-success"
                  >{{ $t('feedback.cavablanm') }}</span>
                  <span
                    v-else-if="o.status === 2"
                    class="badge bg-dark"
                  >{{ $t('feedback.bal') }}</span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <strong class="text-danger">{{ $t('feedback.mracit') }} </strong>  <br>
              {{ o.text }} <br>
              <em class="small">{{ getMoment(o.logTime)}}</em>
              <br>
              <div
                v-if="o.answer"
                class="mt-3"
              >
                <strong class="text-danger">{{ $t('feedback.cavab') }} </strong> <br>
                {{ o.answer }} <br>
                <em class="small">{{ getMoment(o.answerTime)}}</em>
              </div>
            </div>
            <div class="card-footer py-2">
              <div class="d-flex justify-content-between">
                <div />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="mb-3">
            <button
              class="btn btn-lg btn-success w-100"
              @click="openSupport"
            >
              <i class="fa fa-plus" /> {{ $t('feedback.dstkSorusuGndr') }}
            </button>
          </div>


          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{ $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {name: company.name, getCompanyFormat: getCompanyFormat(company.format)}) }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }} <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getFeedbacks,} from "@/repositories/GeneralDataRepository";
import {mediaBase, paymentDomain} from "@/repositories/Repository";
import {
  buildLongId,
  getCompanyFormat,
  getPhoto,
  getProfileName
} from "@/repositories/Utils";
import moment from "moment/moment";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      paymentDomain: paymentDomain,
      requests: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {

    this.getList();

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getList() {
      getFeedbacks(this.token).then(data => {
        if (data.code === 200) {
          this.requests = data.feedbacks;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },

    openSupport() {
      this.$bvModal.show('modal-feedback-form');
    },
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
